export { default } from './B2CLayout';
